var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComparison = function SvgComparison(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.065 6.306V16.99a3.784 3.784 0 0 0 3.784 3.783h10.684a3.784 3.784 0 0 0 3.783-3.783V6.306a3.784 3.784 0 0 0-3.783-3.783H5.849a3.784 3.784 0 0 0-3.784 3.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.274 14.214 9.287 12.2m4.95 2.013H7.274h6.963Zm-6.963 0 2.013 2.013-2.013-2.013ZM15.108 9.21l-2.012 2.013M8.146 9.21h6.962-6.962Zm6.962 0-2.012-2.013 2.012 2.013Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 11.42 10.912)",
    d: "M0 0h21.367v21.367H0z"
  })))));
};
export default SvgComparison;